import { lang } from './keys';
import tr from './locales/tr.json';
import en from './locales/en.json';
import {
  locales, fallbackLocale, defaultLocale, storageKey,
} from './constants';
import { getSelectedLocale, setSelectedLocale } from './helpers';

export const keys = lang;

export const languages = {
  tr,
  en,
};

export {
  locales,
  fallbackLocale,
  defaultLocale,
  storageKey,
  getSelectedLocale,
  setSelectedLocale,
};
